import React, { Component } from 'react';
import { default as Styles } from '../styles';

const Message = ({ h, fill }) => {
  return (
    <div
      style={{
        position: 'relative',
        backgroundColor: fill,
        height: h,
        ...Styles.col_center('center'),
        ...Styles.fill,
      }}
    >
      <p
        style={{
          ...Styles.bold,
          ...Styles.call_to_action,
          ...Styles.uppercase,
        }}
      >
        Chart error
      </p>
    </div>
  );
};
export default class Shield extends Component {
  constructor(props) {
    super(props);
    this.state = { fail: false };
  }

  componentDidCatch(error, info) {
    this.setState({ fail: true });
    // logErrorToMyService(error, info);
  }

  render() {
    return this.state.fail ? <Message {...this.props} /> : this.props.children;
  }
}
